<template>
  <v-dialog v-model="props.modelValue" max-width="680" persistent no-click-animation>
    <v-card>
      <v-card-title class="d-flex justify-space-between align-center">
        Share Product
        <v-btn icon @click="handleClose(true)" size="small">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-form ref="formRef" validate-on="blur">
          <div class="d-flex justify-space-between">
            <label class="form-item-label">From</label>
            <v-text-field v-model="form.from" disabled></v-text-field>
          </div>
          <div class="d-flex justify-space-between">
            <label class="form-item-label">To</label>
            <v-text-field
              class="form-item-field-to"
              placeholder="Please enter the recipient's email address"
              v-model="form.receiveList"
              :rules="rules.receiveList"
            ></v-text-field>
          </div>
          <div class="d-flex justify-space-between">
            <label class="form-item-label">Subject</label>
            <v-text-field
              v-model="form.title"
              :rules="rules.title"
            ></v-text-field>
          </div>
          <div class="d-flex justify-space-between">
            <label class="form-item-label">Message</label>
            <v-textarea
              v-model="form.content"
              :rules="rules.content"
              variant="outlined"
              rows="6"
              no-resize
              clearable
            ></v-textarea>
          </div>
          <v-card-actions class="d-flex justify-end">
            <v-btn
              class="mt-2 px-7 sendEmail"
              border
              height="42"
              @click="handleSendEmail"
              >Send Email</v-btn
            >
          </v-card-actions>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script setup>
import { isEmailCommon } from "kits"
import { systemInteractor,customerInteractor } from "~/core"
import getCachedPromise from "@/utils/getCachedPromise"

const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false
  },
  details: {
    type: Object,
    default: () => {}
  }
})

const emit = defineEmits(["update:modelValue"])

const route = useRoute()

const config = useRuntimeConfig()

const { $BaseClickBurying, $MallPageName, $ClickSource, $Message, $Reporter } =
  useNuxtApp()

const formRef = ref()

const form = reactive({
  from: "",
  receiveList: "",
  title: "",
  content: ""
})

const rules = reactive({
  receiveList: [
    async (value) => {
      if (value) {
        const res = await getCachedPromise("registerMailRule")
        if (!isEmailCommon(value,res)) {
          return "Invalid email address"
        } else {
          const [result] = await customerInteractor.registerMailDnsCheckApi(value)
          if (!result) {
            return "Invalid Email Address"
          }
          return true
        }
      }
      return "Field cannot be blank"
    }
  ],
  title: [
    (value) => {
      if (value) return true
      return "Field cannot be blank"
    }
  ],
  content: [
    (value) => {
      if (value) return true
      return "Field cannot be blank"
    }
  ]
})

watch(
  () => props.modelValue,
  async (v) => {
    form.content = `Hi I hope you're interested in this product.\nPage URL: ${
      config.public.serverBaseUrl
    }${route.fullPath.replace("/", "")} \nThanks!`
    if (v && !form.from) {
      const [res] = await systemInteractor.getShareProductAccountApi()
      if (res) {
        form.from = res
      }
    }
  }
)

const handleClose = (sengGtag) => {
  if (sengGtag) {
    $BaseClickBurying(
      $MallPageName?.mallProductDetail,
      $ClickSource?.mallShareProductClose
    )
    $Reporter.click({event: 'e_share_product_close'})
  }
  form.receiveList = ""
  form.title = ""
  form.content = ""
  formRef.value.resetValidation()
  emit("update:modelValue", false)
}

const handleSendEmail = async () => {
  const { valid } = await formRef.value.validate()
  if (valid) {
    // 邮件内容格式化
    let params = { ...form }
    params.content = params.content.replace(/\n/g, "<br/>")
    let content = params.content.split("<br/>")
    let contentSplit = content[1]?.split("Page URL: ") || []
    contentSplit[0] = "Page URL: "
    contentSplit[1] =
      contentSplit[1] && `<a href="${contentSplit[1]}">${contentSplit[1]}</a>`
    content[1] = content[1] && contentSplit.join("")
    content = content.join("<br/>")
    params.content = content

    const [res, err] = await systemInteractor.sendShareProductEmailApi(params)
    if (!err) {
      $BaseClickBurying(
        $MallPageName?.mallProductDetail,
        $ClickSource?.mallShareProductSuccess
      )
      $Reporter.click({event: 'e_share_product_success'})
      handleClose()
      $Message.success("Email sent successfully")
    }
  }
}
</script>
<style lang="scss" scoped>
.form-item-label {
  width: 80px;
  line-height: 36px;
  font-size: 14px;
  &::before {
    content: "*";
    color: rgb(var(--v-theme-error));
    margin-right: 4px;
  }
}

:deep(.form-item-field-to) {
  flex: 1;
  .v-input__control {
    flex-direction: column;
    &::after {
      content: "RiversPromo respects your privacy, and these addresses will not be shared.";
      margin-top: 4px;
      font-size: 12px;
      color: #777777;
    }
  }
}

:deep(.v-field) {
  .v-field__input {
    font-size: 14px;
  }
  .v-field__clearable {
    font-size: 12px;
  }
}

.sendEmail {
  border-color: #797979;
  transition: all 0.3s;
  &:hover {
    color: #fff;
    background: #0caaf1;
    border-color: #0caaf1;
  }
}
</style>
